import {
    GET_MANAGE_SUBSCRIPTION_LOADING,
    GET_MANAGE_SUBSCRIPTION_SUCCESS,
    GET_MANAGE_SUBSCRIPTION_FAILURE,
    GET_MANAGE_SUBSCRIPTION_RESET
} from '../../actions/types';

const INITIAL_STATE = {
    manageSubscription: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        },
    },
};

const getManageSubscriptionReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_MANAGE_SUBSCRIPTION_LOADING:
            return {
                ...state,
                manageSubscription: {
                    ...state.manageSubscription,
                    get: {
                        ...state.manageSubscription.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.manageSubscription.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_MANAGE_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                manageSubscription: {
                    ...state.manageSubscription,
                    get: {
                        ...state.manageSubscription.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.manageSubscription.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_MANAGE_SUBSCRIPTION_FAILURE:
            return {
                ...state,
                manageSubscription: {
                    ...state.manageSubscription,
                    get: {
                        ...state.manageSubscription.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.manageSubscription.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_MANAGE_SUBSCRIPTION_RESET:
            return {
                ...state,
                manageSubscription: {
                    ...state.login.manageSubscription,
                    get: {
                        ...INITIAL_STATE.manageSubscription.get,
                        reset: true,
                    },
                },
            }
    }
    return state;
}

export default getManageSubscriptionReducers;